export default {
  common: {
    status: {
      list: 'common:get:/company/company_cd/status',
    },
    service: {
      summary: 'common:get:/company/company_cd/service/service_id/summary'
    },
    store: {
      add: 'common:post:/company/company_cd/store',
      delete: 'common:delete:/company/company_cd/store',
      list: 'common:get:/company/company_cd/store',
      get: 'common:get:/company/company_cd/store/store_cd',
      update: 'common:put:/company/company_cd/store/store_cd',
    },
    user: {
      add: 'common:post:/company/company_cd/user',
      delete: 'common:delete:/company/company_cd/user',
      list: 'common:get:/company/company_cd/user',
      get: 'common:get:/company/company_cd/user/user_id',
      update: 'common:put:/company/company_cd/user/user_id',
      store_assign: 'common:put:/company/company_cd/user/user_id/store_assign',
      role_assign: 'common:put:/company/company_cd/user/user_id/role_assign',
      activate: 'common:post:/company/company_cd/user/user_id/activate',
      suspend: 'common:post:/company/company_cd/user/user_id/suspend',
    },
    use_store: {
      list: 'common:get:/company/company_cd',
    },
    role: {
      add: 'common:post:/company/company_cd/role',
      delete: 'common:delete:/company/company_cd/role',
      list: 'common:get:/company/company_cd/role',
      update: 'common:put:/company/company_cd/role/role_id',
    },
    security: {
      get: 'common:get:/company/company_cd/security',
      update: 'common:put:/company/company_cd/security',
    },
    store_holiday: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:store_holiday',
    },
    yosoku_sisu: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:yosoku_sisu',
    },
    span_sales_jogai: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:pos_jogai_span',
    },
    keppin_hosei: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:keppin_hosei'
    },
    nebiki_hosei: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:nebiki_hosei'
    },
    materials: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:materials',
    },
    cannibali_group: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:cannibali_group',
    },
    target_items: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:target_items',
    },
    main_items: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:main_items',
    },
    main_items_add_order: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:main_items_add_order',
    },
    change_dow_setting: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:change_dow_setting',
    },
    daily_budget: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:daily_budget',
    },
    new_set: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:new_set',
    },
    border: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:border',
    },
    bin_anbun: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:bin_anbun',
    },
    delica_stock_hosei: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:delica_stock_hosei',
    },
    category_group: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:category_group',
    },
    store_status_hosei: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:store_status_hosei',
    },
    camp: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:camp',
    },
    item_code_convert: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:item_code_convert',
    },
    sii: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:sii',
    },
    android: {
      link: 'common:get:/android_app_url',
    },
    neire_rate_border: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:neire_rate_border',
    },
    nebiki_hosei_ext: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:nebiki_hosei_ext',
    },
    nohin_teishi: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:nohin_teishi',
    },
    bin_anbun_ext: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:bin_anbun_ext',
    },
    category_group_with_service: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:category_group_with_service',
    },
    delica_camp_spot_nippan_rate: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:delica_camp_spot_nippan_rate',
    },
    min_hacchu: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:min_hacchu',
    },
    order_unit_settings: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:order_unit_settings',
    },
    daily_goal: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:daily_goal',
    },
    kpi_graph_setting: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:kpi_graph_setting',
    },
    kpi_threshold: {
      download: 'common:get:/company/company_cd/export/config_name',
      upload: 'common:import:kpi_threshold',
    },
  },
  zaiko: {
    item: {
      get: 'zaiko:get:/company/company_cd/store/store_cd/item/jan_cd',
      edit: 'zaiko:post:/company/company_cd/store/store_cd/item/jan_cd',
      all_store: 'zaiko:post:/company/company_cd/item',
      history_download: 'zaiko:get:/company/company_cd/category_1/category_1_cd/target_date/type',
      category_1: 'zaiko:get:/company/company_cd/category_1/category_1_cd/target_date/type',
    },
    sales_summary: {
      get: 'zaiko:get:/company/company_cd/sales_summary'
    },
  },
  delica: {
    kankoku: {
      download: 'delica:get:/company/company_cd/store/store_cd/kankoku/delica',
    },
    sales_report: {
      search: 'delica:get:/company/company_cd/store/store_cd/summary/summary_cd',
      download: 'delica:get:/company/company_cd//summary/summary_cd',
    },
    alert_store: {
      search: 'delica:get:/company/company_cd/store/store_cd/category_group/group_cd',
      plan_edit: 'delica:post:/company/company_cd/store/store_cd/item/item_cd/plan_edit',
      alert: 'delica:post:/company/company_cd/store/store_cd/alert',
    },
    kpi: {
      download: 'delica:get:/company/company_cd/kpi/delica',
    },
    target_items: {
      registered_status: {
        list: 'delica:get:/company/company_cd/target_items/registered_status',
        update: 'delica:put:/company/company_cd/target_items/registered_status',
      },
      loss: {
        get: 'delica:get:/company/company_cd/target_items/loss',
        update: 'delica:put:/company/company_cd/target_items/loss',
      },
      category: {
        list: 'delica:get:/company/company_cd/target_items/category',
        add: 'delica:post:/company/company_cd/target_items/category',
        get: 'delica:get:/company/company_cd/target_items/category/category_cd',
        update: 'delica:put:/company/company_cd/target_items/category/category_cd',
        delete: 'delica:delete:/company/company_cd/target_items/category/category_cd',
      },
      category_pattern: {
        list: 'delica:get:/company/company_cd/target_items/category/category_cd/pattern/pattern_cd',
        update: 'delica:put:/company/company_cd/target_items/category/category_cd/pattern/pattern_cd',
        add: 'delica:post:/company/company_cd/target_items/category/category_cd/pattern/pattern_cd/jan_cd',
        delete: 'delica:delete:/company/company_cd/target_items/category/category_cd/pattern/pattern_cd/jan_cd',
        download: 'delica:get:/company/company_cd/target_items/export/category/category_cd/pattern/pattern_cd',
      },
      store_pattern: {
        list: 'delica:get:/company/company_cd/target_items/store_pattern',
        update: 'delica:put:/company/company_cd/target_items/store_pattern',
        download: 'delica:get:/company/company_cd/target_items/export/store_pattern',
      },
      store_category_pattern: {
        list: 'delica:get:/company/company_cd/target_items/store/store_cd/category/category_cd/pattern/pattern_cd',
        update: 'delica:put:/company/company_cd/target_items/store/store_cd/category/category_cd/pattern/pattern_cd',
        download: 'delica:get:/company/company_cd/target_items/export/store/store_cd/category/category_cd/pattern/pattern_cd',
      },
      dounl: {
        
      },
    },
  },
  meat: {
    kankoku: {
      download: 'meat:get:/company/company_cd/store/store_cd/kankoku/meat',
    },
  },
  bread: {
    kankoku: {
      download: 'delica:get:/company/company_cd/store/store_cd/kankoku/bread',
    },
    kpi: {
      download: 'delica:get:/company/company_cd/kpi/bread',
    },
  },
  kpi: {
    kpi: {
      get: 'kpi:get:/company/company_cd/kpi',
    },
    kpi_setting: {
      get: 'kpi:get:/company/company_cd/kpi_setting',
      put: 'kpi:put:/company/company_cd/kpi_setting',
    },
    kpi_threshold: {
      get: 'kpi:get:/company/company_cd/store/store_cd/kpi_threshold',
      put: 'kpi:put:/company/company_cd/store/store_cd/kpi_threshold',
    },
    kpi_refer_company: {
      get: 'kpi:get:/company/company_cd/store/store_cd/kpi_refer_company',
      put: 'kpi:put:/company/company_cd/store/store_cd/kpi_refer_company',
    },
  },
}
